@for (notification of notifications; track notification) {
  <buyiq-notification
    [@slideInOut]
    [notification]="notification"
    (dismissNotification)="onDismissNotification($event)">
  </buyiq-notification>
}
